module.exports = __webpack_public_path__ + "img/6.59f12d4e.jpg";